(function (win, $, eventhub) {
	'use strict';

/* item:
* {
*   "currencyRoundingScale" : 2,
*   "currency"              : "EUR",
*   "id"                    : 55413,
*   "name"                  : "test_1",
*   "imageUrl"              : false,
*   "descriptor"            : "test_1 Rebilling Descriptor: 111 - 112  ( 5 3 2)",
*   "initialAmount"         : 111,
*   "rebillingAmount"       : 112,
*   "startInterval"         : {arr: Array(2), str: "1month  and 1week "},
*   "rebillingInterval"     : {arr: Array(1), str: "15days "},				// Array(1) === [{unit: 'days', value: 15}]
*   "endInterval"           : {arr: Array(3), str: "3years 2months  and 1day "},
*   "termsUrl"              : "",
* ...more
* }
* */

	var uid         = 1;
	var pluginName  = 'Rebilling';
	var defaults    = {
		thousandsSeparator  : ' ',
		currencySeparator   : ' ',
		defaultRoundingScale: 2,
		pluginWrapper       : _.template('<div class="rebilling_item "></div>'),
		templates           : {
			timeInterval :
				'<% var len=arr.length; ' +
				'_.each(arr, function(d, i){ ' +
					'if(len==1){%>' +
						'<%- (d.value == 1 && type === "rebillingInterval" ? "" : d.value)%><%- t(d.unit)%>' +
					'<%} else {%>' +
						'<%if(len-i==1){%><%- t("and")%> <%}%>' +
						'<%- d.value%><%- t(d.unit)%> ' +
					'<%} ' +
				'})%>',
			item_wrapper : '<div><%=header%><%=content%></div>',
			header : '<div class="content-header">' +
				'<h3>' +
					'<span class="price"><span  class="currency"><%- currency_formatted %></span>' +
					'<span class="amount"><%- rebillingAmount.str%></span></span><span class="separator">/</span>' +
					'<span class="period"><span class="period_val"><%= rebillingInterval.str%></span>' +
				'</span>' +
				'</h3>' +
				'<h4> <%= t("billed_every", [rebillingInterval.str])%></h4>' +
				'<div class="underline"></div>' +
			'</div>'
			,
			content : '<div class="item_info_wrapp">' +
					'<div>' +
						'<%if(imageUrl){%><div class="img_wrapp"><img src="<%- imageUrl%>" alt="<%-t(name)%>" height="50" width="50"/></div><%}%>' +
						'<h2><%-t(name)%></h2>' +
					'</div>' +
					'<%= setup_fee_html%>' +
					'<%= trial_html%>' +
					'<%= first_charge_html%>' +
					'<%= ends_on_html%>' +
					'<div class="description"><p><%- descriptor%></p></div>' +
				'</div>' +
				'<%= terms_wrapper_html %>'
			,
			setup_fee : '<div class="setup_fee <%if(!initialAmount.val){%> zero_initial_amount<%}%>"><p class="i_amount">' +
				'<%= t("rebilling_setup_fee",[initialAmount.formatted, dateNow.str])%>' +
				'</p></div>'
			,
			trial : '<%if(startInterval.str){%>' +
				'<div class="trial_period"><p class="i_period">' +
				'<%= t("rebilling_trial_period", [startInterval.str])%>' +
				'</p></div><%}%>'
			,
			first_charge : '<div class="initial "><p class="i_period">' +
				'<%= t("rebilling_first_charge", [rebillingAmount.formatted, firstChargeDate.str])%>' +
				'</p></div>'
			,
			ends_on : '<%if(!isEndlessPlan){%><div class="end"><p class="i_period"><%= t("rebilling_ends_on",[endDate.str])%></p></div><%}%>'
			,
			terms_wrapper : '<div class="underline"></div> <div id="rebilling_terms_wrapper" class="rebilling_terms_wrapper"></div>'
		},
		monthNameArr    : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		dateformatter   : function(date, monthNameArr){ return date.getDate() + ' ' + monthNameArr[date.getMonth()] + ' ' + date.getFullYear(); },
		getIntlNumberFormatter : false, // OR Function
		useFixedFraction: true,
		currencyMap     : {
			'eur' : '€', 'usd' : '$', 'gbp' : '£', 'yen' : '¥', 'ils' : '₪', 'inr' : '₹',
			'rub' : '₽', 'try' : '₺', 'cny' : '¥', 'krw' : '₩', 'zar' : 'R', 'brl' : 'R$'
		},
		getCurrencyFormatter : function (currencyMap, currencySeparator) { return function (currency, value) { if (currency) {
			if (currencyMap[currency.toLowerCase()]){ return currencyMap[currency.toLowerCase()] + currencySeparator + value; }
			return value + " " + currency.toUpperCase();} };
		},
		getNumberFormatter   : function (thousandsSeparator) {
			return function (number, currency, roundingScale) {
				var str = parseFloat(number);
				return str.toFixed(roundingScale).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandsSeparator);
			};
		}
	};

	function _getDateObj( plus_days, plus_months, plus_years){
		var nd = (new Date());
		if(plus_years){
			nd.setFullYear(nd.getFullYear() + plus_years);
		}
		if(plus_months){
			nd.setMonth(nd.getMonth() + plus_months);
		}
		if(plus_days){
			nd.setDate(nd.getDate() + plus_days);
		}
		return nd;
	}

	function Plugin(element, opts) {
		this.$element = $(element);
		this.options = $.extend(true, {}, defaults, opts || {});
		this.init();
	}

	Plugin.prototype.init = function () {
		var self = this;
		this.iScroll = {};
		if (this.options.getIntlNumberFormatter && typeof this.options.getIntlNumberFormatter == 'function') {
			this.formatter = this.options.getIntlNumberFormatter();
		} else {
			var baseCurrencyFormatter = this.options.getCurrencyFormatter(this.options.currencyMap, this.options.currencySeparator);
			var baseNumberFormatter = this.options.getNumberFormatter(this.options.thousandsSeparator);
			var baseGetCurrencySymbol = function (currency) { return baseCurrencyFormatter(currency, "").replace(self.options.currencySeparator, '');};
			this.formatter = {
				formatDecimal: baseNumberFormatter,
				formatCurrency: function adapter(amount, currency, roundingScale) {
					return baseCurrencyFormatter(currency, baseNumberFormatter(amount, currency, roundingScale));
				},
				getCurrencySymbol: baseGetCurrencySymbol,
			}
		}

		this.$pluginWrapper = $(this.options.pluginWrapper());
		this.$wrapper = $('<div></div>');
		this.$pluginWrapper.append(this.$wrapper);
		this.$element.append(this.$pluginWrapper);

		eventhub.subscribe('rebilling-available', this.update, this);
	};

	Plugin.prototype.update = function (data) {
		var self = this;
		data = data || {};
		self.options['data'] = data || {};

		var currency = data.currency || self.options.currency;
		var currencyRoundingScale = isNaN(data.currencyRoundingScale) ? self.options.defaultRoundingScale : parseInt(data.currencyRoundingScale);
		var payload = $.extend(true, {}, data);
		var multiplier = Math.pow(10, currencyRoundingScale);
		_.each(["initialAmount", "rebillingAmount"], function (key, idx, x) {
			if (data.hasOwnProperty(key)) {
				payload[key] = {
					val: (Math.round(parseFloat(data[key]) * multiplier) / multiplier)
				};
				payload[key].str = self.formatter.formatDecimal(payload[key].val, currency, currencyRoundingScale, self.options.useFixedFraction);
				payload[key].formatted = self.formatter.formatCurrency(payload[key].val, currency, currencyRoundingScale, self.options.useFixedFraction);
			}
		});
		payload.currency_formatted    = self.formatter.getCurrencySymbol(currency);
		payload.isEndlessPlan         = !(data.end_days || data.end_months || data.end_years);
		payload.dateNow               = _getDateObj(0, 0, 0);
		payload.dateNow.str           = self.options.dateformatter(payload.dateNow, self.options.monthNameArr);
		payload.firstChargeDate       = _getDateObj(data.start_days, data.start_months, data.start_years);
		payload.firstChargeDate.str   = self.options.dateformatter(payload.firstChargeDate, self.options.monthNameArr);
		payload.endDate               = (payload.isEndlessPlan) ? {} : _getDateObj(data.end_days, data.end_months, data.end_years);
		payload.endDate.str           = (payload.isEndlessPlan) ? '' : self.options.dateformatter(payload.endDate, self.options.monthNameArr);
		payload.startInterval.str     = _.template(self.options.templates.timeInterval)({arr : data.startInterval.arr, type:"startInterval"});
		payload.rebillingInterval.str = _.template(self.options.templates.timeInterval)({arr : data.rebillingInterval.arr, type:"rebillingInterval"});
		payload.endInterval.str       = _.template(self.options.templates.timeInterval)({arr : data.endInterval.arr, type:"endInterval"});
		// console.log('payload', payload );
		self.render(payload);
	};

	Plugin.prototype.render = function (payload) {
		var self = this;
		if (!payload) {
			return;
		}
		payload.first_charge_html   = _.template(self.options.templates.first_charge)(payload);
		payload.trial_html          = _.template(self.options.templates.trial)(payload);
		payload.setup_fee_html      = _.template(self.options.templates.setup_fee)(payload);
		payload.terms_wrapper_html  = _.template(self.options.templates.terms_wrapper)(payload);
		payload.ends_on_html        = _.template(self.options.templates.ends_on)(payload);

		var header_html  = _.template(self.options.templates.header)(payload);
		var content_html = _.template(self.options.templates.content)(payload);
		var $html        = $(_.template(self.options.templates.item_wrapper)({
			content : content_html,
			header  : header_html
		}));
		self.$wrapper.empty().append($html);
	};

	$.fn[pluginName] = function (options) {
		return this.each(function () {
			var _pluginName = 'plugin_' + pluginName;
			if (!$.data(this, _pluginName)) {
				$.data(this, _pluginName, new Plugin(this, options));
				uid += 1;
			}
		});
	}
}(window, $, pubsub));